<template>
  <div id="app">
    <Menu />
    <transition name="page-fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>
<style>
.page-fade-enter {
  transform: translateX(10px);
  opacity: 0;
}
.page-fade-enter-active,
.page-fade-leave-active {
  transition: all 0.2s ease;
}
.page-fade-leave-to {
  transform: translateX(-30px);
  opacity: 0;
}
</style>

<script>
import Menu from "@/components/Menu.vue";
export default {
  components: {
    Menu
  }
};
</script>
